(function () {
  if (window.__mhFulfilmentHydratorLoaded) return;
  window.__mhFulfilmentHydratorLoaded = true;

  var API = 'https://admin.menahub.com/api/fulfilment_resolve.php';
  var cache = {};
  var inflight = {};
  var liveBanners = []; // [{el, expiresAt, stockPct}]

  // Arabic label translation for the delivery pills (cards on /ar).
  var MH_AR = (document.documentElement.lang || '').indexOf('ar') === 0;
  function mhTr(s) {
    if (!MH_AR) return s;
    s = (s == null) ? '' : String(s);
    // Case-insensitive lookup — the label may arrive as "Standard delivery"
    // (lowercase d) or "Standard Delivery" depending on the source.
    var map = { 'tomorrow':'غداً', 'next day':'اليوم التالي', 'same day':'نفس اليوم', 'standard delivery':'توصيل عادي', 'standard':'توصيل عادي', '2 days':'يومين' };
    var key = s.trim().toLowerCase();
    if (map[key]) return map[key];
    return s.replace(/\bdays\b/gi, 'أيام').replace(/\bday\b/gi, 'يوم')
            .replace(/\bhours?\b/gi, function (m) { return m.toLowerCase() === 'hour' ? 'ساعة' : 'ساعات'; })
            .replace(/\bmins?\b/gi, function (m) { return m.toLowerCase() === 'min' ? 'دقيقة' : 'دقائق'; });
  }

  // ── Pill builders ──────────────────────────────────────────────
  function buildYellowPill(label) {
    var ns = 'http://www.w3.org/2000/svg';
    var pill = document.createElement('span');
    pill.className = 'mh-fulfilment-pill mh-fp-split';
    // Next Day / Same Day → blue bar (per request). Tomorrow keeps the yellow.
    if (/^(next day|same day)$/i.test((label || '').trim())) {
      pill.classList.add('mh-fp-split--blue');
    }

    // Left half (yellow gradient): bolt + "Delivery"
    var left = document.createElement('span');
    left.className = 'mh-fp-left';
    var bolt = document.createElementNS(ns, 'svg');
    bolt.setAttribute('viewBox', '0 0 24 24');
    bolt.setAttribute('fill', '#1a1a1a');
    var boltPath = document.createElementNS(ns, 'path');
    boltPath.setAttribute('d', 'M13 2L3 14h8l-1 8 10-12h-8l1-8z');
    bolt.appendChild(boltPath);
    var word = document.createElement('span'); word.textContent = MH_AR ? 'توصيل' : 'Delivery';
    left.appendChild(bolt); left.appendChild(word);

    // Right half (orange gradient, slanted divider): the ETA label
    var right = document.createElement('span');
    right.className = 'mh-fp-right';
    right.textContent = mhTr(label);

    pill.appendChild(left); pill.appendChild(right);
    return pill;
  }

  // Extract the product handle from a card's product link (for the notify CTA).
  function cardHandle(card) {
    var a = card && card.querySelector ? card.querySelector('a[href*="/products/"]') : null;
    if (!a) return '';
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  // Out-of-stock pill — same shape/position as the delivery pill (bottom edge
  // strip). Rendered as a functional "Notify me" CTA (bell icon) that hooks the
  // global .mh-card-notify handler (mh-quickbuy.js) via data-notify-handle, so
  // sold-out cards offer a restock alert instead of a dead "Out of Stock" label.
  function buildOosPill(handle) {
    var ns = 'http://www.w3.org/2000/svg';
    var pill = document.createElement('span');
    pill.className = 'mh-fulfilment-pill mh-fulfilment-pill--oos mh-card-notify';
    if (handle) {
      pill.setAttribute('data-notify-handle', handle);
      pill.setAttribute('role', 'button');
      pill.setAttribute('tabindex', '0');
    }

    var ico = document.createElementNS(ns, 'svg');
    ico.setAttribute('class', 'mh-fp-oos-ico');
    ico.setAttribute('viewBox', '0 0 24 24');
    ico.setAttribute('fill', 'none');
    ico.setAttribute('stroke', 'currentColor');
    ico.setAttribute('stroke-width', '2.2');
    ico.setAttribute('stroke-linecap', 'round');
    ico.setAttribute('stroke-linejoin', 'round');
    var bell = document.createElementNS(ns, 'path');
    bell.setAttribute('d', 'M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9');
    var clap = document.createElementNS(ns, 'path');
    clap.setAttribute('d', 'M13.73 21a2 2 0 0 1-3.46 0');
    ico.appendChild(bell); ico.appendChild(clap);

    var word = document.createElement('span');
    word.className = 'mh-fp-word'; word.textContent = MH_AR ? 'أعلمني' : 'Notify me';
    pill.appendChild(ico); pill.appendChild(word);
    return pill;
  }
  function buildBlueGetIn(label) {
    var pill = document.createElement('span');
    pill.className = 'mh-fulfilment-getin';

    var bolt = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    bolt.setAttribute('class', 'mh-gi-bolt');
    bolt.setAttribute('viewBox', '0 0 24 24');
    bolt.setAttribute('fill', '#FFD700');
    var boltPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    boltPath.setAttribute('d', 'M13 2L3 14h8l-1 8 10-12h-8l1-8z');
    bolt.appendChild(boltPath);

    var label1 = document.createElement('span'); label1.className = 'mh-gi-text'; label1.textContent = MH_AR ? 'احصل خلال' : 'GET IN';
    var eta = document.createElement('span'); eta.className = 'mh-gi-eta'; eta.textContent = MH_AR ? mhTr(label) : label.toUpperCase();

    var arrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    arrow.setAttribute('class', 'mh-gi-arrow');
    arrow.setAttribute('viewBox', '0 0 24 24');
    arrow.setAttribute('fill', '#fff');
    var arrowPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    arrowPath.setAttribute('d', 'M8 5v14l11-7z');
    arrow.appendChild(arrowPath);

    pill.appendChild(bolt);
    pill.appendChild(label1);
    pill.appendChild(eta);
    pill.appendChild(arrow);
    return pill;
  }
  function buildStandard(label) {
    // Quieter grey pill with a small truck icon — used for the default
    // "Standard Delivery" fallback so unconfigured products still
    // communicate something, but visually subordinate to the brighter
    // yellow / blue express pills used for promoted items.
    var s = document.createElement('span');
    s.className = 'mh-fulfilment-pill mh-fulfilment-pill--standard';

    var truck = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    truck.setAttribute('class', 'mh-fp-truck');
    truck.setAttribute('viewBox', '0 0 24 24');
    truck.setAttribute('fill', 'none');
    truck.setAttribute('stroke', 'currentColor');
    truck.setAttribute('stroke-width', '2');
    truck.setAttribute('stroke-linecap', 'round');
    truck.setAttribute('stroke-linejoin', 'round');
    var p1 = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    p1.setAttribute('x', '1'); p1.setAttribute('y', '3');
    p1.setAttribute('width', '15'); p1.setAttribute('height', '13');
    var p2 = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
    p2.setAttribute('points', '16 8 20 8 23 11 23 16 16 16 16 8');
    var c1 = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    c1.setAttribute('cx', '5.5'); c1.setAttribute('cy', '18.5'); c1.setAttribute('r', '2.5');
    var c2 = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    c2.setAttribute('cx', '18.5'); c2.setAttribute('cy', '18.5'); c2.setAttribute('r', '2.5');
    truck.appendChild(p1); truck.appendChild(p2); truck.appendChild(c1); truck.appendChild(c2);

    var word = document.createElement('span');
    word.textContent = mhTr(label);

    s.appendChild(truck);
    s.appendChild(word);
    return s;
  }
  // Purple "GET DELIVERY <label>" pill — same layout as the blue GET IN pill
  // (carries both classes so it inherits all base/edge/mobile rules) with a
  // purple background and a "GET DELIVERY" prefix. Used for digital express
  // (e.g. gift vouchers → "GET DELIVERY WITHIN 2HRS").
  function buildPurpleGetDelivery(label) {
    var pill = document.createElement('span');
    pill.className = 'mh-fulfilment-getin mh-fulfilment-getdelivery';

    var bolt = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    bolt.setAttribute('class', 'mh-gi-bolt');
    bolt.setAttribute('viewBox', '0 0 24 24');
    bolt.setAttribute('fill', '#FFD700');
    var boltPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    boltPath.setAttribute('d', 'M13 2L3 14h8l-1 8 10-12h-8l1-8z');
    bolt.appendChild(boltPath);

    var label1 = document.createElement('span'); label1.className = 'mh-gi-text'; label1.textContent = MH_AR ? 'توصيل خلال' : 'Get Delivered in';
    var eta = document.createElement('span'); eta.className = 'mh-gi-eta'; var etaTxt = (label || '').replace(/^within\s*/i, '').replace(/(\d)(hrs?)/i, '$1 $2').toUpperCase(); eta.textContent = MH_AR ? mhTr(label) : etaTxt;

    var arrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    arrow.setAttribute('class', 'mh-gi-arrow');
    arrow.setAttribute('viewBox', '0 0 24 24');
    arrow.setAttribute('fill', '#fff');
    var arrowPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    arrowPath.setAttribute('d', 'M8 5v14l11-7z');
    arrow.appendChild(arrowPath);

    pill.appendChild(bolt);
    pill.appendChild(label1);
    pill.appendChild(eta);
    pill.appendChild(arrow);
    return pill;
  }
  function buildPill(label, style) {
    if (style === 'get_delivery_purple') return buildPurpleGetDelivery(label);
    if (style === 'get_in_blue') return buildBlueGetIn(label);
    if (style === 'standard') return buildStandard(label);
    return buildYellowPill(label);
  }

  // ── Countdown banner ──────────────────────────────────────────
  function buildCountdownBanner(expiresAtIso, stockPct) {
    var wrap = document.createElement('div');
    wrap.className = 'mh-deal-countdown';
    wrap.setAttribute('data-expires', expiresAtIso);

    var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('class', 'mh-cd-icon');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('fill', '#fff');
    var iconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    iconPath.setAttribute('d', 'M6 2h12v2l-4 6 4 6v2H6v-2l4-6-4-6V2zm2 2v1l4 6-4 6v1h8v-1l-4-6 4-6V4H8z');
    icon.appendChild(iconPath);

    var timer = document.createElement('span');
    timer.className = 'mh-cd-timer';
    timer.textContent = '--:--';

    wrap.appendChild(icon);
    wrap.appendChild(timer);

    if (typeof stockPct === 'number' && stockPct >= 0 && stockPct <= 100) {
      var sep = document.createElement('span'); sep.className = 'mh-cd-sep'; sep.textContent = '·';
      var pct = document.createElement('span'); pct.className = 'mh-cd-stock'; pct.textContent = stockPct + '% Left';
      wrap.appendChild(sep);
      wrap.appendChild(pct);
    }

    return wrap;
  }

  function formatDelta(ms) {
    if (ms <= 0) return null;
    var totalMin = Math.floor(ms / 60000);
    var s = Math.floor((ms % 60000) / 1000);
    var h = Math.floor(totalMin / 60);
    var m = totalMin % 60;
    if (h > 0) {
      return String(h).padStart(2, '0') + 'h:' + String(m).padStart(2, '0') + 'm';
    }
    return String(m).padStart(2, '0') + 'm:' + String(s).padStart(2, '0') + 's';
  }

  function tickCountdowns() {
    if (!liveBanners.length) return;
    var now = Date.now();
    var stillAlive = [];
    liveBanners.forEach(function (b) {
      var ms = b.expiresAt - now;
      var label = formatDelta(ms);
      var timerEl = b.el.querySelector('.mh-cd-timer');
      if (label === null) {
        if (b.el.parentNode) b.el.parentNode.removeChild(b.el);
        return;
      }
      if (timerEl) timerEl.textContent = label;
      stillAlive.push(b);
    });
    liveBanners = stillAlive;
  }

  setInterval(tickCountdowns, 1000);

  // ── Same-day support line (card) ───────────────────────────────
  // Compact, clickable contact shown below the label marquee, only for
  // products whose fulfilment label is "Same Day".
  function buildCardSupport() {
    var svgNS = 'http://www.w3.org/2000/svg';
    var wrap = document.createElement('div');
    wrap.className = 'mh-card-sds';

    var ph = document.createElementNS(svgNS, 'svg');
    ph.setAttribute('viewBox', '0 0 24 24'); ph.setAttribute('fill', 'none');
    ph.setAttribute('stroke', 'currentColor'); ph.setAttribute('stroke-width', '2');
    ph.setAttribute('stroke-linecap', 'round'); ph.setAttribute('stroke-linejoin', 'round');
    var pp = document.createElementNS(svgNS, 'path');
    pp.setAttribute('d', 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z');
    ph.appendChild(pp);

    var call = document.createElement('a');
    call.href = 'tel:+97431114248';
    call.textContent = '+974 3111 4248';

    var wa = document.createElement('a');
    wa.className = 'mh-card-sds__wa';
    wa.href = 'https://wa.me/97431114248?text=' +
              encodeURIComponent('Hi, I need help with my same-day delivery order.');
    wa.target = '_blank'; wa.rel = 'noopener';
    wa.setAttribute('aria-label', 'WhatsApp support');
    var waIco = document.createElementNS(svgNS, 'svg');
    waIco.setAttribute('viewBox', '0 0 24 24'); waIco.setAttribute('fill', 'currentColor');
    var waP = document.createElementNS(svgNS, 'path');
    waP.setAttribute('d', 'M12 2a10 10 0 0 0-8.6 15L2 22l5.1-1.3A10 10 0 1 0 12 2zm5.3 14.2c-.2.6-1.3 1.2-1.8 1.2-.5.1-1 .1-1.7-.1-.4-.1-1-.3-1.6-.6-2.9-1.2-4.7-4.1-4.9-4.3-.1-.2-1.1-1.5-1.1-2.8 0-1.3.7-2 .9-2.2.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 1.9c.1.2.1.4 0 .5l-.4.6c-.2.2-.3.4-.1.7.2.3.8 1.3 1.7 2.1 1.2 1 2.1 1.4 2.4 1.5.2.1.4.1.6-.1l.7-.9c.2-.2.4-.2.6-.1l1.8.9c.3.1.4.2.5.3.1.2.1.7-.1 1.3z');
    waIco.appendChild(waP);
    wa.appendChild(waIco);

    wrap.appendChild(ph);
    wrap.appendChild(call);
    wrap.appendChild(wa);
    return wrap;
  }

  function addCardSupport(card) {
    var info = card.querySelector('.mh-card-info');
    if (!info || info.querySelector('.mh-card-sds')) return;
    var sds = buildCardSupport();
    var labelSlot = info.querySelector('.mh-label-slot');
    var strip = info.querySelector('.mh-delivery-strip');
    if (labelSlot) {
      info.insertBefore(sds, labelSlot.nextSibling); // directly below the marquee
    } else if (strip) {
      info.insertBefore(sds, strip); // above the bottom delivery bar
    } else {
      info.appendChild(sds);
    }
  }

  // ── Paint per card ─────────────────────────────────────────────
  function ensureStrip(card) {
    var strip = card.querySelector('.mh-delivery-strip');
    if (strip) return strip;
    // Generic cards (e.g. recommendation "Pair it with") expose an explicit
    // slot; .mh-card-info is the product-card-new convention.
    var info = card.querySelector('[data-mh-fulfil-slot]') ||
               card.querySelector('.mh-card-info');
    if (!info) return null;
    strip = document.createElement('div');
    strip.className = 'mh-delivery-strip';
    info.appendChild(strip);
    return strip;
  }

  function paint(card, fulfilment) {
    if (card.hasAttribute('data-fulfilment-loaded')) return;
    card.setAttribute('data-fulfilment-loaded', '1');
    if (!fulfilment) return;

    // If the storefront already marks this product out of stock (Shopify
    // availability via data-available="false", or a Liquid-rendered OOS bar),
    // NEVER show a delivery badge — the "Out of Stock" bar is the only footer.
    // This wins even when the backend fulfilment data still says in-stock
    // (stale stock), so a sold-out product can't show "Delivery Tomorrow".
    if (card.getAttribute('data-available') === 'false' ||
        card.querySelector('.mh-card-oos-bar, .mh-oos-badge')) {
      return;
    }

    // Out of stock → show an "Out of Stock" pill in the SAME bottom strip
    // where the delivery badge would sit (red, with icon). product-card-new
    // already renders its own bottom OOS bar (.mh-card-oos-bar) in Liquid, so
    // we skip those to avoid a duplicate; this fills the gap on deal-page
    // manual cards (no availability data). No delivery pill for OOS.
    if (fulfilment.reason === 'out_of_stock') {
      var hasOos = card.querySelector('.mh-card-oos-bar, .mh-oos-badge, .mh-fulfilment-pill--oos');
      if (!hasOos) {
        var oosStrip = ensureStrip(card);
        if (oosStrip && !oosStrip.querySelector('.mh-fulfilment-pill--oos')) {
          oosStrip.insertBefore(buildOosPill(cardHandle(card)), oosStrip.firstChild);
          oosStrip.classList.add('mh-delivery-strip--edge');
        }
      }
      return;
    }

    if (!fulfilment.show_badge) return;

    // 1. Bottom pill into the delivery strip
    var strip = ensureStrip(card);
    if (strip && !strip.querySelector('.mh-tag-express, .mh-fulfilment-pill, .mh-fulfilment-getin')) {
      var label = fulfilment.label || 'Tomorrow';
      var style = fulfilment.pill_style || 'express_yellow';
      var pill = buildPill(label, style);
      strip.insertBefore(pill, strip.firstChild);
      // Full-width, edge-to-edge bottom bar (no white space around the badge).
      strip.classList.add('mh-delivery-strip--edge');
    }

    // 1b. Same-day only: clickable support number below the label marquee.
    if ((fulfilment.label || '').toLowerCase().trim() === 'same day') {
      addCardSupport(card);
    }

    // 2. Top-left countdown banner (only if backend sent a timer block)
    if (fulfilment.timer && fulfilment.timer.expires_at) {
      var imageWrap = card.querySelector('.mh-card-image-wrap');
      if (imageWrap && !imageWrap.querySelector('.mh-deal-countdown')) {
        var expiresAt = Date.parse(fulfilment.timer.expires_at.replace(' ', 'T'));
        if (!isNaN(expiresAt) && expiresAt > Date.now()) {
          var stockPct = (typeof fulfilment.timer.stock_percent_left === 'number')
            ? fulfilment.timer.stock_percent_left
            : null;
          var banner = buildCountdownBanner(fulfilment.timer.expires_at, stockPct);
          imageWrap.appendChild(banner);
          liveBanners.push({ el: banner, expiresAt: expiresAt, stockPct: stockPct });
          tickCountdowns();
        }
      }
    }
  }

  function flushFromCache(cards) {
    cards.forEach(function (card) {
      var id = card.getAttribute('data-product-id');
      if (id && cache[id]) paint(card, cache[id]);
    });
  }

  function fetchBatch(ids, allCards) {
    if (!ids.length) return;
    ids.forEach(function (id) { inflight[id] = true; });
    var numericIds = ids.map(function (x) { return parseInt(x, 10); });

    fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(Object.assign({ product_ids: numericIds }, (function(){ var sa = /(?:^|; )mh_market=sa(?:;|$)/.test(document.cookie); var ar = (document.documentElement.lang || '').indexOf('ar') === 0 || /^\/ar(\/|$)/.test(location.pathname); return sa ? { market: 'sa', lang: ar ? 'ar' : 'en' } : {}; })()))
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        if (!json || !json.fulfilment) return;
        Object.keys(json.fulfilment).forEach(function (k) {
          cache[k] = json.fulfilment[k];
          delete inflight[k];
        });
        flushFromCache(allCards);
      })
      .catch(function () {
        ids.forEach(function (id) { delete inflight[id]; });
      });
  }

  function scan() {
    var cards = Array.prototype.slice.call(
      document.querySelectorAll(
        '.mh-card[data-product-id]:not([data-fulfilment-loaded]),' +
        '[data-mh-fulfil][data-product-id]:not([data-fulfilment-loaded])'
      )
    );
    if (!cards.length) return;
    var needFetch = [];
    var seen = {};
    cards.forEach(function (card) {
      var id = card.getAttribute('data-product-id');
      if (!id || cache[id] || inflight[id] || seen[id]) return;
      seen[id] = true;
      needFetch.push(id);
    });
    while (needFetch.length > 100) {
      var slice = needFetch.splice(0, 100);
      fetchBatch(slice, cards);
    }
    if (needFetch.length) fetchBatch(needFetch, cards);
    flushFromCache(cards);
  }

  function init() {
    setTimeout(scan, 100);
    if (typeof MutationObserver === 'undefined') return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; scan(); }, 250);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
